import { useCallback, useEffect, useRef, useState } from 'react';

/** `copied` flips true then resets after `resetMs`. Timer is unmount-safe —
 * a pending reset is cleared on unmount so it never fires against a torn-down
 * environment (GTMOPS-2191: this fired after jsdom teardown and threw
 * `ReferenceError: window is not defined`, failing the test run). */
export function useCopiedFlash(resetMs = 1200) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (timerRef.current !== null) clearTimeout(timerRef.current);
  }, []);

  const flashCopied = useCallback(() => {
    setCopied(true);
    if (timerRef.current !== null) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(false), resetMs);
  }, [resetMs]);

  return [copied, flashCopied] as const;
}
